import React, { useEffect, useState } from "react";
import "./newtry.css";
// import { FaHome, FaInfoCircle, FaBoxOpen, FaEnvelope } from 'react-icons/fa';
// import { useLocation } from 'react-router-dom';

export default function HamburgerMenu() {

  const [open, setOpen] = useState(false);
  useEffect(() => {
    document.body.classList.toggle("no-scroll", open);
    return () => document.body.classList.remove("no-scroll");
  }, [open]);

  return (
    <div className="burger">
      <input
        type="checkbox"
        id="main-navigation-toggle"
        className="btn btn--close"
        title="Toggle main navigation"
        checked={open}
        onChange={() => setOpen(!open)}
      />
      <label htmlFor="main-navigation-toggle" aria-controls="main-navigation" aria-expanded={open}>
        <span></span>
      </label>

      <nav id="main-navigation" className="nav-main" role="navigation" aria-label="Main">
        <ul className="bgmenu">
          <li className="bg_menu__item">
            <a className="menu__link" href="/">Home</a>
          </li>
          <li className="bg_menu__item">
            <a className="menu__link" href="/about">About</a>
          </li>

          <li className="bg_menu__item">
            <a className="menu__link" href="/products">Products</a>
            {/* <ul className="submenu" role="bgmenu">
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Burger King</a>
              </li>
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Southwest Airlines</a>
              </li>
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Levi Strauss</a>
              </li>
            </ul> */}
          </li>

          <li className="bg_menu__item">
            <a className="menu__link" href="/contact">Contact</a>
            {/* <ul className="submenu" role="bgmenu">
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Print Design</a>
              </li>
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Web Design</a>
              </li>
              <li className="bg_menu__item">
                <a className="menu__link" href="#0">Mobile App Development</a>
              </li>
            </ul> */}
          </li>

          {/* <li className="bg_menu__item">
            <a className="menu__link" href="#0">Contact</a>
          </li> */}
        </ul>

        
      </nav>
    </div>
  );
}